<div class = "success-content">
		<div class="alert alert-success" role="alert">
				Successfully Added Subscription
		</div>

		<button (click)="navigate()" style = "border-radius:25px;padding:5px;padding-right:25px;padding-left:25px;font-weight: bold;background-color:#6E1FD2;border-color:#6E1FD2;display:flex;margin:0 auto;" class = "btn-primary">View My Subscriptions</button>
</div>